import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

// Effort Timelines API Methods
export const timelineService = {
  // Get all timelines for a specific effort
  getTimelines: async (effortId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/efforts/${effortId}/timelines/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching timelines:", error);
      throw error;
    }
  },

  // Create a new timeline for an effort
  createTimeline: async (effortId, timelineData) => {
    try {
      const payload = {
        date: timelineData.date,
        timeline: timelineData.timeline,
      };

      const response = await axios.post(
        `${baseUrl}/api/business/efforts/${effortId}/timelines/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating timeline:", error);
      throw error;
    }
  },

  // Update an existing timeline
  updateTimeline: async (effortId, timelineId, timelineData) => {
    try {
      const payload = {
        date: timelineData.date,
        timeline: timelineData.timeline,
      };

      const response = await axios.put(
        `${baseUrl}/api/business/efforts/${effortId}/timelines/${timelineId}/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating timeline:", error);
      throw error;
    }
  },

  // Delete a timeline
  deleteTimeline: async (effortId, timelineId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/efforts/${effortId}/timelines/${timelineId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting timeline:", error);
      throw error;
    }
  },

  // Milestone-related methods
  milestones: {
    // Get milestones for a specific timeline
    getMilestones: async (effortId, timelineId) => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/business/efforts/${effortId}/timelines/${timelineId}/milestones/`,
          getConfig()
        );
        return response.data.data;
      } catch (error) {
        console.error("Error fetching milestones:", error);
        throw error;
      }
    },

    // Add a new milestone to a timeline
    createMilestone: async (effortId, timelineId, milestoneData) => {
      try {
        const payload = {
          timeline: timelineId,
          where: milestoneData.where,
          what: milestoneData.what,
          host: milestoneData.host,
          link: milestoneData.link,
        };

        const response = await axios.post(
          `${baseUrl}/api/business/efforts/${effortId}/timelines/${timelineId}/milestones/`,
          payload,
          getConfig()
        );
        return response.data.data;
      } catch (error) {
        console.error("Error creating milestone:", error);
        throw error;
      }
    },

    // Update an existing milestone
    updateMilestone: async (
      effortId,
      timelineId,
      milestoneId,
      milestoneData
    ) => {
      try {
        const payload = {
          where: milestoneData.where,
          what: milestoneData.what,
          host: milestoneData.host,
          link: milestoneData.link,
          additional_info: milestoneData.additionalInfo,
        };

        const response = await axios.put(
          `${baseUrl}/api/business/efforts/${effortId}/timelines/${timelineId}/milestones/${milestoneId}/`,
          payload,
          getConfig()
        );
        return response.data.data;
      } catch (error) {
        console.error("Error updating milestone:", error);
        throw error;
      }
    },

    // Delete a milestone
    deleteMilestone: async (effortId, timelineId, milestoneId) => {
      try {
        const response = await axios.delete(
          `${baseUrl}/api/business/efforts/${effortId}/timelines/${timelineId}/milestones/${milestoneId}/`,
          getConfig()
        );
        return response.status === 204;
      } catch (error) {
        console.error("Error deleting milestone:", error);
        throw error;
      }
    },
  },
};

export default timelineService;
